module.exports = __webpack_public_path__ + "img/icon_religion.36407a36.svg";